import { ChangeDetectorRef, Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { CrewAvailability, DriverLicense } from 'src/app/core/graphql/generated/gen-types';
import { Availabilities } from '../../../features/crew/availabilities';

@Component({
	selector: 'app-crew-badge',
	templateUrl: './crew-badge.component.html',
	styleUrls: ['./crew-badge.component.scss'],
})
export class CrewBadgeComponent implements OnInit {
	@Input() crew;
	@Input() groundCrews;
	@Input() event: Event;
	@Input() disableTooltip = false;
	@Input() showAvailability = false;
	@Input() highlight = false;

	availabilities = Availabilities;
	groundCrewNames: string;
	rvHookup: boolean = false;

	NOTIFY = 30;
	crewAvailability = CrewAvailability;

	constructor() {}

	ngOnInit(): void {
		// only first word of every name of every crew in groundCrews
		this.groundCrewNames = this.groundCrews?.map((p) => p.crew.name.split(' ')[0]).join(', ');
		this.rvHookup = this.groundCrews?.filter((gc) => gc.crew.driverLicenseCategory === DriverLicense.Be).length > 0;
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.groundCrews && changes.groundCrews.currentValue) {
			this.groundCrewNames = this.groundCrews?.map((p) => p.crew.name.split(' ')[0]).join(', ');
			this.rvHookup = this.groundCrews?.filter((gc) => gc.crew.driverLicenseCategory === DriverLicense.Be).length > 0;
		}
	}

	getAvailability(availability: CrewAvailability) {
		const foundAvailability = this.availabilities.find((p) => p.availability === availability);
		return foundAvailability;
	}
}
